/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { ILabTestItem } from 'app/shared/model/lab-test-item.model';
import { IDiagLabPanel } from 'app/shared/model/diag-lab-panel.model';

export interface IDiagLabPanelItem {
  id?: string;
  active?: boolean | null;
  lastupdated?: number | null;
  microSec?: number | null;
  timestampentry?: number | null;
  cursor?: number;
  sortOrder?: number | null;
  lcTestItem?: ILabTestItem | null;
  panel?: IDiagLabPanel | null;
  childPanel?: IDiagLabPanel | null;
}

export const defaultValue: Readonly<IDiagLabPanelItem> = {
  active: false,
};
